import React from 'react';
import { Avatar, Box, Button, Chip, Typography } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import PersonIcon from '@mui/icons-material/Person';
import { format } from 'date-fns';

export default function CommentItem({ comment, onFixRequest, onMarkIntentional, onResolve, provider = 'github', line, disableFix = false, fixApplied = false, intentionalStaged = false, renderBody }) {
  let author = comment?.author || comment?.Author || comment?.createdBy?.displayName || comment?.user?.name || 'Unknown';
  const rawDate = comment?.created_at || comment?.createdAt || comment?.createdDate || comment?.updated_at || comment?.updatedAt || comment?.lastUpdatedDate || comment?.date || '';
  let dateLabel = 'Unknown date';
  if (rawDate) {
    const dateObj = new Date(rawDate);
    if (!isNaN(dateObj.getTime())) dateLabel = format(dateObj, 'MMM d, yyyy');
    else if (typeof rawDate === 'string' && rawDate.trim().length > 0) dateLabel = rawDate;
  }
  return (
    <Box sx={{ backgroundColor: '#0d1117', border: '1px solid #30363d', borderRadius: '6px', mt: 2, mb: 2, overflow: 'hidden', '&:hover': { borderColor: '#58a6ff' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', p: '12px 16px', backgroundColor: '#161b22', borderBottom: '1px solid #30363d' }}>
        <Avatar sx={{ width: 32, height: 32, backgroundColor: '#58a6ff', mr: 2 }}>
          <PersonIcon fontSize="small" />
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, color: '#f0f6fc', fontSize: '14px' }}>{author}</Typography>
          <Typography variant="caption" sx={{ color: '#c9d1d9', fontSize: '12.6px' }}>{dateLabel}</Typography>
        </Box>
        {intentionalStaged ? (
          <Chip label="Marked intentional (staged)" size="small" sx={{ backgroundColor: '#3d2e00', color: '#ffa657', border: '1px solid #f0ad36' }} />
        ) : fixApplied ? (
          <Chip label="Fix applied" size="small" sx={{ backgroundColor: '#122e1b', color: '#7ee787', border: '1px solid #238636' }} />
        ) : (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button size="small" startIcon={<BuildIcon />} variant="outlined" onClick={() => onFixRequest(comment, line)} disabled={disableFix} sx={{ color: disableFix ? '#f85149' : '#58a6ff', borderColor: disableFix ? '#f85149' : '#58a6ff', '&:hover': { backgroundColor: disableFix ? '#f8514920' : '#58a6ff', color: disableFix ? '#f85149' : '#0d1117' }, '&.Mui-disabled': { color: '#f85149', borderColor: '#f85149', backgroundColor: '#f8514920' } }}>Fix</Button>
            {!disableFix && (
              <Button size="small" variant="outlined" onClick={() => onMarkIntentional(comment)} sx={{ color: '#ffa657', borderColor: '#f0ad36', '&:hover': { backgroundColor: '#f0ad3620' } }}>Mark intentional</Button>
            )}
            {provider === 'azure' && typeof onResolve === 'function' && (
              <></>
            )}
          </Box>
        )}
      </Box>
      <Box sx={{ p: '16px', backgroundColor: '#0d1117' }}>
        <Typography component="div" variant="body2" sx={{ color: '#f0f6fc', lineHeight: 1.6, fontSize: '14px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {typeof renderBody === 'function' ? renderBody(comment) : null}
        </Typography>
      </Box>
    </Box>
  );
}



